export const ERROR_TEXT = {
  GENERIC: {
    HEADING: `We're sorry, but our website is currently experiencing technical difficulties.`,
    SUB_HEADING: `We're working to fix the issue and restore service as soon as possible. Please try again later`,
    BUTTON_TEXT: 'Try Again',
  },
  SOMETHING_WENT_WRONG: {
    HEADING: `Oops! Something went wrong.`,
    SUB_HEADING: `Either click on RELOAD or go back to previous state of the application.`,
    BUTTON_TEXT: 'RELOAD',
  },
}

export enum ErrorTypes {
  FAILED_TO_FETCH = 'Failed to fetch',
  LOAD_FAILED = 'Load failed',
}

export const CLIENT_SIDE_ERROR_CODES = [401, 404, 500]
